import React from "react";
import { useApp } from "@/context/AppContext";

const LEVELS = ["todos", "familiar", "principiante", "intermedio", "avanzado", "muy_avanzado"];

export const DifficultyFilter = ({ value, onChange, options = LEVELS, testid = "difficulty" }) => {
  const { t } = useApp();
  return (
    <div className="-mx-4 px-4 sm:mx-0 sm:px-0 flex gap-2.5 overflow-x-auto sm:flex-wrap sm:overflow-visible [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid={`${testid}-filter`}>
      {options.map((lvl) => (
        <button
          key={lvl}
          onClick={() => onChange(lvl)}
          data-testid={`${testid}-chip-${lvl}`}
          className={`shrink-0 whitespace-nowrap rounded-full border px-5 py-2 text-sm transition-colors duration-300 ${
            value === lvl
              ? "bg-[#6E7E56] text-white border-[#6E7E56]"
              : "bg-white text-[#3D4A43] border-[#E2DFD7] hover:border-[#6E7E56]"
          }`}
        >
          {t.difficulty[lvl] || t.category[lvl]}
        </button>
      ))}
    </div>
  );
};

export const CategoryFilter = ({ value, onChange }) => {
  const { t } = useApp();
  const cats = ["todos", "cumbre", "senderismo", "camping", "canonismo", "playa", "cascadas", "turistico", "otros"];
  return (
    <div className="-mx-4 px-4 sm:mx-0 sm:px-0 flex gap-2.5 overflow-x-auto sm:flex-wrap sm:overflow-visible [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="category-filter">
      {cats.map((c) => (
        <button key={c} onClick={() => onChange(c)} data-testid={`category-chip-${c}`}
          className={`shrink-0 whitespace-nowrap rounded-full border px-5 py-2 text-sm transition-colors duration-300 ${
            value === c ? "bg-[#6E7E56] text-white border-[#6E7E56]" : "bg-white text-[#3D4A43] border-[#E2DFD7] hover:border-[#6E7E56]"
          }`}>
          {t.category[c]}
        </button>
      ))}
    </div>
  );
};
